(function () {
  // Get the current pathname
  const currentPath = window.location.pathname;
  console.log("Current Path:", currentPath);

  // Define the special redirection case
  const specialRedirectPath = "/user/short-form-med";
  const specialRedirectBaseURL =
    "https://{{settings.primary_domain}}/account/register";

  // Define the redirection mapping (Column 2 & 3 → Column 4)
  const redirectMap = {
    "/mfgm-สารอาหารที่พบในนมแม่": "/pages/mfgm",
    "/digestive-care-center": "/pages/digestion",
    "/pages/feeding-needs/digestion": "/pages/digestion",
    "/yellow-milk": "/pages/yellow-milk",
    "/pages/feeding/yellow-milk": "/pages/yellow-milk",
    "/baby-allergy-expert": "/pages/child-allergy",
    "/pages/feeding-needs/child-allergy": "/pages/child-allergy",
    "/baby-allergy-test": "/pages/child-allergy/test",
    "/pages/feeding-needs/child-allergy/test": "/pages/child-allergy/test",
    "/breastfeeding": "/pages/breastfeeding",
    "/pages/feeding/breastfeeding": "/pages/breastfeeding",
    "/first-1000-days": "/pages/first-1000-days",
    "/pages/baby-development/first-1000-days": "/pages/first-1000-days",
    "/choose-the-right-enfa": "/pages/choose-the-right-enfa",
    "/pages/feeding-needs/choose-the-right-enfa":
      "/pages/choose-the-right-enfa",
    "/enfa-kitchen": "/pages/enfa-kitchen",
    "/pages/feeding/enfa-kitchen": "/pages/enfa-kitchen",
    "/sleep-and-brain-development": "/pages/sleep",
    "/pages/brain/sleep": "/pages/sleep",
    "/pages/brain/executive-function": "/pages/executive-function",
    "/caesarean-section": "/pages/c-section",
    "/pages/feeding-needs/c-section": "/pages/c-section",
    "/blogs/baby-development-newborn/improve-new-born-development":
      "/blogs/baby-development-newborn/caring-for-a-newborn",
    "/blogs/baby-development-tips/warning-signs":
      "/blogs/baby-development-newborn/caring-for-a-newborn",
    "/blogs/feeding-needs-digestion-symptoms/burping-tips":
      "/blogs/baby-development-newborn-milestones/baby-1-month-old",
    "/blogs/baby-development-newborn-milestones/baby-development-month-1-tips":
      "/blogs/baby-development-newborn-milestones/baby-1-month-old",
    "/blogs/baby-development-newborn/2-months-development":
      "/blogs/baby-development-newborn-milestones/babys-growth-and-development-2-months-old",
    "/blogs/baby-development-newborn-milestones/activities-for-3-months":
      "/blogs/baby-development-newborn-milestones/babys-growth-and-development-3-months-old",
    "/blogs/feeding-needs-digestion-baby-poop/3-months-issues":
      "/blogs/baby-development-newborn-milestones/babys-growth-and-development-3-months-old",
    "/blogs/baby-development-infant/5-months-development":
      "/blogs/baby-development-infant-milestones/babys-growth-and-development-5-months-old",
    "/blogs/baby-development-infant/activities-for-6-months":
      "/blogs/baby-development-infant-milestones/babys-growth-and-development-6-months-old",
    "/blogs/baby-development-infant/activites-for-8-months-old":
      "/blogs/baby-development-infant-milestones/babys-growth-and-development-8-months-old",
    "/blogs/baby-development-infant/activities-for-9-months":
      "/blogs/baby-development-infant-milestones/babys-growth-and-development-9-months-old",
    "/blogs/baby-development-tips/ear-infection":
      "/blogs/baby-development-infant-milestones/babys-growth-and-development-11-months-old",
    "/blogs/baby-development-toddler-milestones/baby-1-year-old":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-12-months-old",
    "/blogs/baby-development-toddler/activities-for-13-months":
      "/blogs/baby-development-toddler-milestones/13-months-milestones",
    "/blogs/feeding/solve-picky-eating":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-14-months-old",
    "/blogs/baby-development-toddler/activities-for-14-months":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-14-months-old",
    "/blogs/baby-development-toddler/1-year-4-months-development":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-16-months-old",
    "/blogs/baby-development-tips/drink-from-straw":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-16-months-old",
    "/blogs/baby-development-toddler/activities-for-16-months":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-16-months-old",
    "/blogs/baby-development-toddler/1-year-5-months-development":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-17-months-old",
    "/blogs/baby-development-toddler/activities-for-18-months":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-18-months-old",
    "/blogs/baby-development-tips/hernia-in-children":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-18-months-old",
    "/blogs/baby-development-toddler/toddlers-at-table":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-18-months-old",
    "/blogs/baby-development-toddler/1-year-7-months-development":
      "/blogs/baby-development-toddler-milestones/babys-growth-and-development-19-months-old",
    "/blogs/baby-development-toddler-milestones/babys-growth-and-development-20-months-old":
      "/blogs/baby-development-toddler/1-year-8-months-development",
    "/blogs/baby-development-toddler/activities-for-20-months":
      "/blogs/baby-development-toddler/1-year-8-months-development",
    "/blogs/baby-development-toddler/1-year-9-months-development":
      "/blogs/baby-development-toddler-milestones/21-months-milestones",
    "/blogs/baby-development-tips/tartar-on-children":
      "/blogs/baby-development-toddler-milestones/21-months-milestones",
    "/blogs/baby-development-toddler/22-months-development":
      "/blogs/baby-development-toddler/1-year-10-months-development",
    "/blogs/baby-development-toddler/23-months-development":
      "/blogs/baby-development-toddler/1-year-11-months-development",
    "/blogs/baby-development-toddler/24-months-development":
      "/blogs/baby-development-toddler-milestones/toddler-2-years",
    "/blogs/baby-development-parenting-tips/bad-breath":
      "/blogs/baby-development-infant/2-years-1-month-development",
    "/blogs/baby-development-toddler/activities-for-26-months":
      "/blogs/baby-development-toddler/2-years-2-months-development",
    "/blogs/baby-development-toddler/30-months-development":
      "/blogs/baby-development-toddler-milestones/2-years-6-months-tips",
    "/blogs/brain/biting":
      "/blogs/baby-development-toddler/2-years-8-months-development",
    "/blogs/baby-development-toddler/3-years-development":
      "/blogs/brain/3-year-old-tantrums",
    "/blogs/baby-development-toddler/3-years-6-months-development":
      "/blogs/baby-development-toddler/3-years-6-months",
    "/blogs/baby-development-toddler/afternoon-napping":
      "/blogs/baby-development-toddler/3-years-6-months",
    "/blogs/baby-development-children/4-years-old-tips":
      "/blogs/baby-development-children-milestones/babys-growth-and-development-4-years",
    "/blogs/baby-development-toddler/4-years-1-month-health":
      "/blogs/baby-development-toddler/4-years-1-month-development",
    "/blogs/baby-development-children/dental-care":
      "/blogs/baby-development-toddler/4-years-3-months-development",
    "/blogs/baby-development-children/snoring-in-children":
      "/blogs/baby-development-toddler/4-years-4-months-development",
    "/blogs/baby-development-parenting-tips/how-to-handle-pink-eye":
      "/blogs/baby-development-toddler/4-years-11-months-development",
    "/blogs/baby-development-children/5-years-health":
      "/blogs/baby-development-children-milestones/babys-growth-and-development-5-years",
    "/blogs/baby-development-tips/wound-care":
      "/blogs/baby-development-toddler/5-years-2-months-development",
    "/blogs/baby-development-children/headaches-in-children":
      "/blogs/baby-development-children/5-years-3-months-development",
    "/blogs/feeding-needs-digestion-baby-poop/constipation-issues":
      "/blogs/baby-development-children/5-years-7-months-development",
    "/blogs/baby-development-children/5-years-8-months-health":
      "/blogs/baby-development-toddler/5-years-8-months-development",
    "/blogs/baby-development-children/5-years-10-months-health":
      "/blogs/baby-development-toddler/5-years-10-months-development",
    "/blogs/pregnancy-maternal-nutrition/protien-for-pregnancy":
      "/blogs/pregnancy-maternal-nutrition/protein-for-pregnant-women",
    "/pages/crea-shop?category-l4-filter=formula-3": "/pages/product-series",
    "/blogs/pregnancy/skin-condtion-during-pregnancy":
      "/blogs/pregnancy/how-to-prevent-stretch-marks",
    "/blogs/pregnancy-maternal-nutrition/nourish-food-for-pregnancy":
      "/blogs/pregnancy-maternal-nutrition/pregnancy-diet",
    "/blogs/baby-development/preventing-kids-smartphone-addiction":
      "/blogs/brain/smartphone-addiction",
    "/blogs/pregnancy/frequent-urinationn":
      "/blogs/pregnancy/frequent-urination",
    "/blogs/baby-development-newborn/newborn-care-guide":
      "/blogs/baby-development-newborn/caring-for-a-newborn",
  };

  // Preserve query parameters (UTMs, etc.)
  const queryParams = window.location.search;

  // Special case: Redirect /user/short-form-med
  if (currentPath === specialRedirectPath) {
    const specialRedirectURL = queryParams
      ? `${specialRedirectBaseURL}${queryParams}`
      : specialRedirectBaseURL;
    console.log("Redirecting to:", specialRedirectURL);
    window.location.replace(specialRedirectURL);
    return; // Stop further execution
  }

  // Check if current path is in redirectMap
  if (redirectMap[currentPath]) {
    const newPath = redirectMap[currentPath];
    const redirectURL = newPath + queryParams;
    console.log("Redirecting to:", redirectURL);
    window.location.replace(redirectURL);
  }
})();
